export default {
  title: "Comments",
  add_comment: "Add comment",
  reply: "Reply",
  replay_comment: "Reply comment",
  placeholder_title: "No comments yet",
  placeholder_subtitle: "Be the first on commenting",
};
